// Lightweight GDPR cookie-consent state (mirrors the kanarix.es landing).
// Cookie-based trackers (GA4, Meta Pixel, Clarity) only load / fire once the visitor
// has accepted. Umami is cookieless and runs regardless.
const KEY = 'kx_cookie_consent';
export const CONSENT_EVENT = 'kx-consent';

export type ConsentChoice = 'accepted' | 'rejected';

export function getConsent(): ConsentChoice | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'accepted' || v === 'rejected' ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(choice: ConsentChoice): void {
  try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: choice })); } catch { /* ignore */ }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent() === 'accepted';
}
